import { red } from '@mui/material/colors';
import ModalForm from 'components/Form/ModalForm';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { TRACKABLE_EVENTS, trackEventBudget } from 'helpers/trackerHelpers';
import { useDeleteProjectsMutation } from '../hooks/useDeleteProject';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    projectId: number;
    inscriptionsCount: number;
};

const DeleteProjectModal: React.FC<Props> = ({
    isOpen,
    onClose,
    projectId,
    inscriptionsCount,
}) => {
    const { t } = useTranslation();
    const { mutate: deleteProjectMutation } = useDeleteProjectsMutation();

    const deleteProject = () => {
        trackEventBudget(
            TRACKABLE_EVENTS.budget.settings.projects.confirmDelete,
        );
        deleteProjectMutation({ projectId });
    };

    const getDeleteConfirmationProjectText = () => {
        let labelInscriptionsDependencies;
        switch (inscriptionsCount) {
            case 0:
                labelInscriptionsDependencies = '';
                break;
            case 1:
                labelInscriptionsDependencies = (
                    <Trans i18nKey="adminBudgetSpace.removeProjectModal.projectOneInscriptions" />
                );
                break;
            default:
                labelInscriptionsDependencies = (
                    <Trans
                        i18nKey="adminBudgetSpace.removeProjectModal.projectNInscriptions"
                        count={inscriptionsCount}
                    />
                );
                break;
        }
        return labelInscriptionsDependencies;
    };

    return (
        <ModalForm
            show={isOpen}
            closeModal={onClose}
            submit={() => deleteProject()}
            submitText={t('common.delete')}
            title={t(
                'adminBudgetSpace.removeProjectModal.deletionConfirmation',
            )}
            secondary={getDeleteConfirmationProjectText()}
            submitClass="e2e-confirm-delete-user-button"
            confirmButtonColor={red[900]}
        />
    );
};

export default DeleteProjectModal;
